import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Field, Form } from 'react-final-form';
import { makeStyles } from '@material-ui/core';
import { ButtonDeactivate, ButtonSaveAndClose } from 'theme';
import asyncValidate from './asyncValidate';
import Save from '@material-ui/icons/Save';
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Typography,
  
  TextField,
} from '@material-ui/core';
import {
  renderCheckbox,
  renderSelectField,
  renderSnackbarError,
  renderTextField
} from 'components/form-global-components/hooks-form-components-for-react-final-form';
const useStyles = makeStyles((theme) => ({
  error500TextColor: {
    color: '#F44336',
    padding: theme.spacing(1, 2)
  }
}));

import { changePassword, generationNewPassword } from "components/module-login/actions/actions-auth";

/*** SPECIFIC TO THIS APP --- START */
import LoginAssignProgramsList from './login-assign-programs-list'                                              
/*** SPECIFIC TO THIS APP --- END */

function LoginForm(props) {
  const classes = useStyles();

  const dispatch = useDispatch();

  const [autoGeneratedPassword, setAutoGeneratedPassword] = useState( generationNewPassword() );

  const handleSubmitSaveAndClose = (values) => {
    let loginName = values.login.replace(/\s/g, '');
    loginName = loginName.toLowerCase();
    if (props.componentMode === 0) {
      var params = {};
      params = {
        createdAt: Date(),
        name: values.name,
        login: loginName,
        role: values.role,
        loginenabled: 1,
        password: values.password
      };
      props.saveEntry(params);
    } else {
      params = {
        name: values.name,
        login: loginName,
        role: values.role,
        // loginenabled: values.loginenabled,
        loginenabled: values.loginenabled ? 1 : 0
      };
      props.saveEntry(values.id, params);
    }
  };

  const resetPassword = () => {
    var params = {
      password: autoGeneratedPassword,
    };
    dispatch(changePassword(props.initialValues.id, params));
    alert("Password Reset \r\n Please write this down: \r\n  \r\n " + autoGeneratedPassword)
  };


/*** SPECIFIC TO THIS APP --- START */
const assignProgram = (programID) => {
  let params = {
    'loginid': props.initialValues.id,
    'programid': programID
  }
      props.loginAssignProgram(params,props.initialValues.id);
};
const unAssignProgram = (programID) => {
  let params = {
    'loginid': props.initialValues.id,
    'programid': programID
  }
      props.loginUnAssignProgram(params,props.initialValues.id);
};
/*** SPECIFIC TO THIS APP --- END */


  return (
    /*** react final form wrapper */
    <Form
      subscription={{ initialValues: true }}
      onSubmit={handleSubmitSaveAndClose}
      initialValues={props.initialValues}
      validate={asyncValidate}
      render={({
        handleSubmit,
        submitting,
        pristine,
        reset,
        valid,
        values,
        ...other
      }) => (
        <form
          onSubmit={handleSubmit}
          // onSubmit={event => { handleSubmit(event).then(reset); }}
        >
          <Card>
            <CardHeader title="Login" />
            <Divider />
            <CardContent>
              <Field
                component={renderSnackbarError}
                id="notifyFormErrors"
                name="notifyFormErrors"
              />

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    component={renderTextField}
                    id="name"
                    name="name"
                    label="Name"
                    placeholder="First and Last Name"
                    footerMessage="First and Last Name"
                    autoFocus
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    locked={props.componentMode === 1 ? true : false}
                    component={renderTextField}
                    id="login"
                    name="login"
                    label="Login ID"
                    placeholder="Login ID"
                    footerMessage="Email address preferred"
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    component={renderSelectField}
                    id="role"
                    name="role"
                    objName="role"
                    label="Login Role"
                    footerMessage=""
                    requireOnChangeMethod={false}
                    dataArray={props.loginroles.map((loginrole) => ({
                      value: loginrole.id,
                      label: loginrole.description,
                    }))}
                  />
                </Grid>
              </Grid>

              {props.componentMode === 1 ? (
                <>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Field
                        component={renderCheckbox}
                        locked={props.locked}
                        id="loginenabled"
                        name="loginenabled"
                        objName="loginenabled"
                        label="Login Enabled"
                        footerMessage=""
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        id="autoGeneratedPassword"
                        name="autoGeneratedPassword"
                        value={autoGeneratedPassword}
                        locked="true"
                        // label={ "Auto generated password.  Please write this password down before clicking the reset button." }
                        helperText="Auto generated password.  Please write this password down before clicking the reset button."
                        hinttext="Auto generated password.  Please write this password down before clicking the reset button."
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <ButtonSaveAndClose
                        size="large"
                        fullWidth
                        onClick={() => {
                          resetPassword();
                        }}
                      >
                        RESET PASSWORD
                      </ButtonSaveAndClose>
                    </Grid>
                  </Grid>
                </>
              ) : (
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Field
                      component={renderTextField}
                      locked={true}
                      id="password"
                      name="password"
                      label="Auto generated password"
                      placeholder="Auto generated password.  Please write this password down before clicking the reset button."
                      footerMessage="Auto generated password.  Please write this password down before clicking the reset button."
                    />
                  </Grid>
                </Grid>
              )}



{/* 
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <ButtonDeactivate
                    size='large'
                    fullWidth
                    onClick={() => {
                      handleSubmitDeactivateLogin()
                    }}
                  >
                    {/ * <Block /> * /}
                    &nbsp;
                    DEACTIVATE REMOVE-EMPLOYEE
                  </ButtonDeactivate>  
                </Grid>
              </Grid>
*/}

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  {/*** SPECIFIC TO THIS APP */}
                  {props.componentMode === 1 ? (
                    <>
                      <LoginAssignProgramsList
                        programsNotAssigned={props.programsNotAssigned}
                        programsAssigned={props.programsAssigned}
                        funcAssignProgram={assignProgram}
                        funcUnAssignProgram={unAssignProgram}
                      />
                    </>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
            </CardContent>

            {props.errors.length > 0 ? (
              <>
                {props.errors[0].status === 501 ? (
                  <Typography
                    component="h1"
                    variant="h4"
                    className={classes.error500TextColor}
                  >
                    {props.errors[0].data.message}
                    <br />
                  </Typography>
                ) : null}
              </>
            ) : null}

            <Divider />
            <CardActions>
              <ButtonSaveAndClose
                size="large"
                type="submit"
                disabled={submitting}
                // valid doesnt work not needed as if asyncValidate errors the form automatically
                // stops the handleSubmit from happening
                // pristine has an issue since initial values loads before the data appears so the form
                // will never bee pristine
                // disabled={
                //   props.componentMode === 0
                //     ? !valid || submitting
                //     : !valid || submitting || pristine
                // }
              >
                <Save />
                &nbsp; Save
              </ButtonSaveAndClose>
            </CardActions>
          </Card>
        </form>
      )}
    />
  );
}

export default LoginForm;
